import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'REACTIVE_MAINTENANCE_ISSUES',
    itemActionName: 'MAINTENANCE_ISSUE',
});
